// import http from '@/axios/http'
//
// const post = ({ headers, data, url = '/robots' }) => {
//   headers = {
//     'Content-Type': 'application/json',
//     ...headers
//   }
//
//   return http
//     .post(
//       url,
//       data,
//       { headers }
//     )
//     .then(response => response.data)
// }

import http from '@/axios/http'

export const createCategory = (info) => {
  const token = localStorage.getItem('token')
  return http
    .post('/create_category', { ...info }, {
      headers: { 'Content-Type': 'application/json', ...(token ? { Auth: token } : {}) }
    })
    .then(response => response.data)
}
